module.exports = __webpack_public_path__ + "img/code.c73cefcf.png";